/**
 * Categorías de gasto (tabla type_expense del molde): 1 = gastos de ruta (cobro), 2 = caja principal, 3 = gastos de sede (oficina),
 * 4 = seguros. Los gastos de ruta y de sede siempre restan.
 */
export const SUBTRACT_ONLY_CATEGORY_IDS = ['1', '3'];
export const SUBTRACT_OPERATION_ID = '2';

export const isSubtractOnlyCategory = (categoryId: string | number | undefined | null) =>
  categoryId !== undefined && categoryId !== null && SUBTRACT_ONLY_CATEGORY_IDS.includes(String(categoryId));
